import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { Card, CardHeader, CardBody, Row, Col, Button, Input, Label, Form, FormGroup, Alert, FormFeedback } from 'reactstrap'
import { ClosableImage, MainLoader } from '../../../../components'
import { validationHelper, normalizeHelper } from '../../../../common/helpers'
import { messages, roles } from '../../../../common/constants'
import { getStores } from '../../../../store/store/actions'
import { toast } from 'react-toastify'
import { getRoles } from '../../../../store/role/actions'
import { getDocumentTypes } from "../../../../store/document-type/actions"
import { getUser, updateUser, resetUpdateUser, resetUserDetail, uploadUserPhoto, deleteUserPhoto } from '../../../../store/user/actions'
import { FilePond, registerPlugin } from 'react-filepond'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType);

class UserEdit extends Component {

    constructor(props) {
        super(props)

        this.state = {
            photo: null,
            withCurrentPhoto: false,
            currentPhotoRemoved: false
        }

        this.onSubmitUser = this.onSubmitUser.bind(this);
        this.renderStoresField = this.renderStoresField.bind(this);
        this.renderRolesField = this.renderRolesField.bind(this);
        this.renderDocumentTypeField = this.renderDocumentTypeField.bind(this);
    }


    async componentDidMount() {
        await this.props.getStores()
        await this.props.getRoles()
        await this.props.getUser(this.props.match.params.id)
        this.props.getDocumentTypes()
    }

    componentDidUpdate(prevProps) {
        this.checkUserFetch(prevProps)
        this.checkUserUpdate(prevProps)
        this.checkUploadUserPhoto(prevProps)
        this.checkDeleteUserPhoto(prevProps)
    }

    checkUserFetch(prevProps) {
        if (prevProps.initialValues == null && this.props.initialValues != null) {
            const { photoUrl } = this.props.initialValues
            if (photoUrl) this.setState({ withCurrentPhoto: true });
        }
    }

    componentWillUnmount() {
        this.props.resetUserDetail();
        this.props.resetUpdateUser();
    }

    checkUserUpdate(prevProps) {
        if (prevProps.updatedUser == null && this.props.updatedUser != null) {
            const { withCurrentPhoto, photo, currentPhotoRemoved } = this.state
            const { id } = this.props.match.params;

            if (!withCurrentPhoto && photo != null) {
                this.props.uploadUserPhoto(id, photo);
                return;
            } else if (currentPhotoRemoved && photo == null) {
                this.props.deleteUserPhoto(id);
                return;
            }

            this.onSuccess()
        }
    }

    checkUploadUserPhoto(prevProps) {
        if (prevProps.uploadedPhoto == null && this.props.uploadedPhoto != null) {
            this.onSuccess()
        }

        if (prevProps.uploadPhotoError == null && this.props.uploadPhotoError != null) {
            this.onSuccess('Sin embargo, no se ha podido guardar la foto.')
        }
    }

    checkDeleteUserPhoto(prevProps) {
        if (!prevProps.deletePhotoSuccess && this.props.deletePhotoSuccess) {
            this.onSuccess()
        }
    }

    onSuccess(message = '') {
        let toastMessage = `Usuario actualizado satisfactoriamente. ${message}`
        toast.success(toastMessage)
        this.props.history.push('/administration/users')
    }

    onSubmitUser(values) {
        this.props.updateUser(this.props.match.params.id, values)
    }

    renderInputField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false
        const labelClass = field.labelClass ? field.labelClass : 'mt-1'

        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label className={labelClass} >{field.label}</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} invalid={hasError} type={field.type} />
                    {hasError == true ?
                        <FormFeedback>{error}</FormFeedback>
                        : null}
                </Col>
            </FormGroup>
        )
    }

    renderStoreItems() {
        return this.props.stores.map(store => {
            return (
                <option key={store.id} value={store.id}>{store.name}</option>
            )
        })
    }

    renderStoresField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false

        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label htmlFor="select">Tienda:</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} type="select" invalid={hasError} >
                        <option key={0} value={0}>Seleccione...</option>
                        {this.renderStoreItems()}
                    </Input>
                    {hasError == true ?
                        <FormFeedback>{error}</FormFeedback>
                        : null}
                </Col>
            </FormGroup>
        )
    }

    renderRoleItems() {
        return this.props.roles.map(store => {
            return (
                <option key={store.id} value={store.id}>{store.name}</option>
            )
        })
    }

    renderRolesField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false

        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label htmlFor="select">Rol:</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} type="select" invalid={hasError} >
                        <option key={0} value={0}>Seleccione...</option>
                        {this.renderRoleItems()}
                    </Input>
                    {hasError == true ?
                        <FormFeedback>{error}</FormFeedback>
                        : null}
                </Col>
            </FormGroup>
        )
    }

    renderDocumentTypeField(field) {
        const {
            meta: { touched, error }
        } = field;
        const hasError = touched && error ? true : false;

        return (
            <FormGroup row>
                <Col md="2" lg="1">
                    <Label htmlFor="select">Tipo de Documento *:</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} type="select" invalid={hasError}>
                        <option key={0} value={0}>
                            Seleccione...
                        </option>
                        {this.renderDocumentItems()}
                    </Input>
                    {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
                </Col>
            </FormGroup>
        );
    }

    renderDocumentItems() {
        return this.props.documentTypes.map(document => {
            return (
                <option key={document.id} value={document.id}>
                    {document.name}
                </option>
            );
        });
    }

    renderInputFile() {
        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label>Foto:</Label>
                </Col>
                <Col xs="12" md="5">
                    <FilePond
                        ref={ref => this.pond = ref}
                        labelIdle='Arrastra y Suelta una foto o <span class="filepond--label-action"> Elige </span>'
                        acceptedFileTypes='image/jpeg, image/png'
                        labelFileTypeNotAllowed='Archivo no válido'
                        onupdatefiles={(fileItems) => {
                            if (fileItems.length == 0) return;
                            this.setState({ photo: fileItems[0].file })
                        }}
                        onremovefile={(file) => {
                            this.setState({ photo: null })
                        }}
                    />
                </Col>
            </FormGroup>
        )
    }

    renderUserPhotoField() {
        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label>Foto:</Label>
                </Col>
                <Col xs="12" md="5">
                    <ClosableImage
                        src={this.props.initialValues.photoUrl}
                        onClose={(e) => {
                            e.preventDefault()
                            this.setState({ withCurrentPhoto: false, currentPhotoRemoved: true });
                        }}
                    />
                </Col>
            </FormGroup >
        )
    }
    render() {

        const { handleSubmit, error, loading, loadingStores, loadingRoles, updatedLoading, updatedError, roleIdValue, uploadPhotoLoading, deletePhotoLoading, initialValues, documentTypesLoading } = this.props
        const isLoadingFetch = (loading || loadingStores || loadingRoles || documentTypesLoading)
        const isLoadingSubmit = (updatedLoading || uploadPhotoLoading || deletePhotoLoading)
        if (error) {
            return (
                <Alert color="danger">
                    {error}
                </Alert>
            )
        }
        if (isLoadingFetch) {
            return <MainLoader />
        }
        if (!this.props.initialValues) return <MainLoader></MainLoader>
        return (
            <div className='animated'>
                <Card>
                    <CardHeader>
                        Editar Usuario
                    </CardHeader>
                    <CardBody>
                        {
                            updatedError && (
                                <Alert color="danger">
                                    {updatedError}
                                </Alert>
                            )
                        }
                        <Form onSubmit={handleSubmit(handleSubmit(this.onSubmitUser))} >
                            <Field name='name' label='Nombre *:' type='text' component={this.renderInputField} normalize={normalizeHelper.noSpecialsField()} />
                            <Field name='document_type_id' component={this.renderDocumentTypeField} />
                            <Field name='dni' label='N° de documento:' type='text' component={this.renderInputField} normalize={normalizeHelper.numberOnlyField(8)} />
                            <Field name='email' label='Email *:' type='text' component={this.renderInputField} normalize={normalizeHelper.emailOnlyField()} />
                            <Field name='phone' label='Teléfono:' type='text' component={this.renderInputField} normalize={normalizeHelper.numberOnlyField(9)} />
                            {
                                this.state.withCurrentPhoto ? this.renderUserPhotoField() : this.renderInputFile()
                            }
                            {
                                initialValues.role_id !== roles.SUPER_ADMIN && <Field name='role_id' component={this.renderRolesField} />
                            }
                            {
                                (roleIdValue == roles.STORE_MANAGER || roleIdValue == roles.CASHIER) && <Field name='store_id' component={this.renderStoresField} />
                            }
                            <Field name='password' label='Contraseña:' type='password' component={this.renderInputField} />
                            <Field name='confirm_password' label='Confirmar Contraseña:' labelClass='mt-0' type='password' component={this.renderInputField} />
                            <Row>
                                <Col className='mt-3'>
                                    <Button type='submit' disabled={isLoadingSubmit} color='primary' className='mr-2' ><i className="fa fa-save mr-1" /> Guardar</Button>
                                    <Button color='secondary' onClick={() => this.props.history.push('/administration/users')} ><i className="fa fa-chevron-left mr-1" /> Cancelar</Button>
                                </Col>
                            </Row>

                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

function validate(values) {
    const errors = {}

    if (validationHelper.stringIsNullOrEmpty(values.name)) {
        errors.name = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.lettersOnly(values.name)) {
        errors.name = messages.LETTERS_ONLY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.document_type_id) || values.document_type_id == "0") {
        errors.document_type_id = messages.MANDATORY_FIELD;
    }

    if (!validationHelper.isNumber(values.dni, 8) && !validationHelper.stringIsNullOrEmpty(values.dni)) {
        errors.dni = messages.DNI_FORMAT_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.email)) {
        errors.email = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.isEmail(values.email)) {
        errors.email = messages.EMAIL_FORMAT_FIELD
    }

    if (!validationHelper.isPhone(values.phone) && !validationHelper.stringIsNullOrEmpty(values.phone)) {
        errors.phone = messages.PHONE_FORMAT_FIELD
    }

    if (String(values.password).localeCompare(values.confirm_password) != 0) {
        errors.confirm_password = messages.NO_MATCH_PASSWORD_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.role_id) || values.role_id == '0') {
        errors.role_id = messages.MANDATORY_FIELD
    }


    if (values.role_id == roles.STORE_MANAGER || values.role_id == roles.CASHIER) {
        if (validationHelper.stringIsNullOrEmpty(values.store_id) || values.store_id == '0') {
            errors.store_id = messages.MANDATORY_FIELD
        }
    } else delete values.store_id

    return errors
}

const formSelector = formValueSelector('UserEditForm')

function mapStateToProps(state) {

    const { user, error, loading } = state.user.activeUser
    const { updateUser, uploadPhoto, deleteUserPhoto } = state.user
    return {
        stores: state.store.storeList.stores,
        roles: state.role.roleList.roles,
        loading,
        error,
        documentTypes: state.documentType.documentTypeList.documentTypes,
        documentTypesLoading: state.documentType.documentTypeList.loading,
        updatedUser: updateUser.user,
        updatedError: updateUser.error,
        updatedLoading: updateUser.loading,
        uploadedPhoto: uploadPhoto.photoUrl,
        uploadPhotoLoading: uploadPhoto.loading,
        uploadPhotoError: uploadPhoto.error,
        deletePhotoSuccess: deleteUserPhoto.success,
        deletePhotoLoading: deleteUserPhoto.loading,
        deletePhotoError: deleteUserPhoto.error,
        initialValues: user,
        roleIdValue: formSelector(state, 'role_id'),
        loadingStores: state.store.storeList.loading,
        loadingRoles: state.role.roleList.loading,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStores,
        getUser,
        updateUser,
        resetUpdateUser,
        resetUserDetail,
        getRoles,
        getDocumentTypes,
        uploadUserPhoto,
        deleteUserPhoto
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'UserEditForm',
    touchOnBlur: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    validate
})(UserEdit))




// WEBPACK FOOTER //
// ./src/scenes/Administration/User/UserEdit/UserEdit.js